import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { CuentaContable } from '../_models/cuenta-contable';
import {CuentaContableControl} from '../_models/cuenta-contable-control';

@Injectable({
  providedIn: 'root'
})
export class CuentaContableService {
  private rutServicio = AppSettings.rutServiciosHOJAEVALUACION + '/api/cuentasContables/';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as CuentaContable[] ) );
  }

  listadoHabilitados() {
    return this.httpClient.get( this.rutServicio + 'enabled' ).pipe( map( res => res as CuentaContable[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + id ).pipe( map( res => res as CuentaContable ) );
  }

  obtenerPorCodigoSeccionYCodigoControl( codSeccion: string, codControl: string ) {
    return this.httpClient.get( this.rutServicio + 'control/' + codControl + '/seccion/' + codSeccion ).pipe( map( res => res as CuentaContableControl ) );
  }

  actualizarHijos( id: string ) {
    return this.httpClient.get( this.rutServicio + 'configurarTipoEstadoFinancieroHijos/' + id ).pipe( map( res => res as CuentaContable[] ) );
  }

  crear( regCrear: CuentaContable ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as CuentaContable ) );
  }

  actualizar( regActualizar: CuentaContable ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: CuentaContable[] ) {
    regActualizar.map( ( s: CuentaContable ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httpClient.post( this.rutServicio + 'bulk', regActualizar ).pipe( map( res => res as CuentaContable[] ) );
  }

  buscar( str: string ) {
    return this.httpClient.get( this.rutServicio + 'buscar/' + str + '/' ).pipe( map( res => res as CuentaContable[] ) );
  }

  listadoCuentaProducto(idProducto: string, codigoTipoEstadoFinanciero:string) {
    return this.httpClient.get( this.rutServicio + 'cuentasContablesHojaEvaluacion/producto/' + idProducto + '/tipoEstadoFinanciero/codigo/' + codigoTipoEstadoFinanciero).pipe( map( res => res as CuentaContable[] ) );
  }

  codigoCrezcamos(cuentaContable:string) {
    return this.httpClient.get( this.rutServicio + 'codigoCrezcamos/' + cuentaContable).pipe( map( res => res as CuentaContable ) );
  }
  codigoCrezcamosIn(cuentaContable: any) {
    return this.httpClient.post( this.rutServicio + 'codigoCrezcamos/in', cuentaContable ).pipe( map( res => res as CuentaContable[] ) );
  }
}
